import { RolesForSelectClubOfficers } from '@domain/clubs';

export const isCES = (role: string) =>
  role === RolesForSelectClubOfficers.ClubExecutiveSecretaryOrDirector;
